import { dispatchCustomEvent } from '../tools/helpers';
import { CONFIG } from './config';


let moduleClasses = {};

export function setModuleClasses(moduleClassesToSet) {
  moduleClasses = moduleClassesToSet;
}

/**
 * Parse string to comma separated module names (per [data-module])
 * @param nameList
 * @return {Array}
 */
export const parseModuleNameList = nameList => (nameList || '').split(',').map(name => name.trim());

/**
 * Generate {moduleName, element} for provided root element
 * @param rootElement
 * @param useSubModule (bool) - define if submodules or modules should get initialized
 * @param selectorSubModule (string) - limit submodules selection to specific type
 * @param parentModuleInstance (instance) - instance of parent module if is submodule
 * @return {*[]}
 */
const collectModuleElements = ({
  rootElement,
  useSubModule = false,
  selectorSubModule = null,
  parentModuleInstance = null,
}) => {
  const dataModuleAttribute = useSubModule ? 'data-submodule' : 'data-module';
  let dataModuleSelector = dataModuleAttribute;

  // limit which submodules to init
  if (useSubModule && selectorSubModule) {
    dataModuleSelector = `${dataModuleAttribute}="${selectorSubModule}"`;
  }

  const $moduleWrappers = [...rootElement.querySelectorAll(`[${dataModuleSelector}]`)];

  // in case of submodule also add root element to module list (if not especially specified)
  if (useSubModule && !selectorSubModule && rootElement.getAttribute(dataModuleAttribute)) {
    $moduleWrappers.push(rootElement);
  }

  const nameElementMaps = $moduleWrappers
    .map(($el) => {
      const moduleNames = parseModuleNameList($el.getAttribute(dataModuleAttribute));
      return moduleNames
        .map(name => ({
          element: $el,
          name,
          parentModuleInstance,
        }));
    });
  // flatten list
  return [].concat(...nameElementMaps);
};

/**
 * Initialize single Module/ModuleInitializer
 *
 * @param element - Node
 * @param name - Module Name (Class Name)
 * @param parentModuleInstance (instance) - instance of parent module if is submodule
 * @return {null}
 */
export function initSingleModule({ element, name, parentModuleInstance = null }) {
  const ModuleConstructor = moduleClasses[name];

  if (ModuleConstructor && !element.moduleInitialized) {
    try {
      const instance = new ModuleConstructor({ element, parentModuleInstance });
      instance.init();
      Object.assign(element.dataset, { moduleInitialized: 'true' });
      return instance;
    } catch (error) {
      console.error(`error initializing module instance with class "${name}"`);
      console.error(error);
    }
  } else {
    console.warn(`Module "${name}" not found.`);
  }

  return null;
}

/**
 * Search and Initialize known js modules in provided element
 * @param rootElement
 * @param useSubModule (bool) - define if submodules or modules should get initialized
 * @param selectorSubModule (string) - limit submodules selection to specific type
 * @param parentModuleInstance (instance) - instance of parent module if is submodule
 * @return {any[]}
 */
export default function initModules({
  rootElement,
  useSubModule = false,
  selectorSubModule = null,
  parentModuleInstance = null,
}) {
  const moduleDataList = collectModuleElements({ rootElement, useSubModule, selectorSubModule, parentModuleInstance });
  const initializedModules = moduleDataList.map(initSingleModule)
  // get rid of failed modules
    .filter(module => !!module);

  if (!useSubModule) {
    dispatchCustomEvent(CONFIG.events.MODULES_INITIALIZATION_COMPLETE);
  }

  return initializedModules;
}



// WEBPACK FOOTER //
// ./src/javascript/main/initModules.js